import React from "react";
import { Routes, Route } from "react-router-dom";
import HistorialCliente from "../pages/HistorialCliente";

const HistorialClienteRoutes = () => {
    return (
        <Routes>
            <Route path=":codServicioCliente" element={<HistorialCliente />} />
        </Routes>
    );
}
export default HistorialClienteRoutes;